import { useState, useEffect } from 'react'
import AdminTable from '../../components/admin/AdminTable'
import AdminForm from '../../components/admin/AdminForm'
import { motion, AnimatePresence } from 'framer-motion'

const API = import.meta.env.VITE_API_URL || '/api'

function getHeaders() { const token = localStorage.getItem('token'); return { 'Content-Type': 'application/json', Authorization: token ? `Bearer ${token}` : '' } }

const fields = [
  { name: 'title', label: 'Title', type: 'text' as const, required: true, placeholder: 'Project Title' },
  { name: 'category', label: 'Category', type: 'select' as const, options: [
    { value: 'web-design', label: 'Web Design' }, { value: 'development', label: 'Development' },
    { value: 'ecommerce', label: 'eCommerce' }, { value: 'seo', label: 'SEO' }, { value: 'branding', label: 'Branding' },
  ]},
  { name: 'client', label: 'Client Name', type: 'text' as const, placeholder: 'Client Name' },
  { name: 'date', label: 'Date (YYYY-MM)', type: 'text' as const, placeholder: '2025-12' },
  { name: 'thumbnail', label: 'Thumbnail URL', type: 'text' as const, placeholder: '/images/port-01.jpg' },
  { name: 'url', label: 'Project URL', type: 'url' as const, placeholder: 'https://...' },
  { name: 'description', label: 'Description', type: 'textarea' as const },
  { name: 'technologies', label: 'Technologies (JSON array)', type: 'json' as const },
  { name: 'images', label: 'Images (JSON array)', type: 'json' as const },
  { name: 'featured', label: 'Featured', type: 'checkbox' as const, placeholder: 'Show on homepage' },
  { name: 'sort_order', label: 'Sort Order', type: 'number' as const },
]

export default function AdminPortfolio() {
  const [items, setItems] = useState<any[]>([])
  const [editing, setEditing] = useState<any | null>(null)
  const [showForm, setShowForm] = useState(false)
  const [loading, setLoading] = useState(true)
  const [saving, setSaving] = useState(false)

  const fetchItems = async () => {
    const res = await fetch(`${API}/portfolio`)
    setItems(await res.json())
    setLoading(false)
  }
  useEffect(() => { fetchItems() }, [])

  const handleSave = async (data: any) => {
    setSaving(true)
    const isNew = !editing
    const res = await fetch(isNew ? `${API}/portfolio` : `${API}/portfolio/${data.id}`, {
      method: isNew ? 'POST' : 'PUT',
      headers: getHeaders(),
      body: JSON.stringify(data),
    })
    if (res.ok) { await fetchItems(); setShowForm(false); setEditing(null) }
    setSaving(false)
  }

  const handleDelete = async (item: any) => {
    const res = await fetch(`${API}/portfolio/${item.id}`, { method: 'DELETE', headers: getHeaders() })
    if (res.ok) await fetchItems()
  }

  const columns = [
    { key: 'thumbnail', label: '', render: (v: string) => v ? <img src={v} className="w-10 h-8 object-cover rounded" /> : '—' },
    { key: 'title', label: 'Title', render: (v: string) => <span className="font-medium">{v}</span> },
    { key: 'category', label: 'Category', render: (v: string) => <span className="text-xs bg-white/10 px-2 py-1 rounded">{v}</span> },
    { key: 'featured', label: 'Featured', render: (v: boolean) => v ? '⭐' : '—' },
  ]

  return (
    <div>
      <div className="flex items-center justify-between mb-6">
        <h1 className="text-2xl font-bold text-white">Portfolio</h1>
        <button onClick={() => { setEditing(null); setShowForm(true) }} className="px-4 py-2 bg-electric-blue hover:bg-electric-blue/80 text-white rounded-lg transition-colors text-sm">+ Add Project</button>
      </div>
      <div className="bg-gray-900 border border-white/10 rounded-xl p-5">
        <AdminTable columns={columns} data={items} onEdit={(item) => { setEditing(item); setShowForm(true) }} onDelete={handleDelete} loading={loading} />
      </div>
      <AnimatePresence>
        {showForm && (
          <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }} className="fixed inset-0 z-50 bg-black/60 flex items-start justify-center pt-20 p-4 overflow-y-auto">
            <motion.div initial={{ scale: 0.95, opacity: 0 }} animate={{ scale: 1, opacity: 1 }} exit={{ scale: 0.95, opacity: 0 }} className="bg-gray-900 border border-white/10 rounded-2xl p-6 w-full max-w-2xl">
              <h2 className="text-xl font-bold text-white mb-6">{editing ? 'Edit Project' : 'Add Project'}</h2>
              <AdminForm fields={fields} initial={editing || { id: `proj-${Date.now()}`, title: '', category: 'web-design', thumbnail: '', images: [], description: '', client: '', date: '', url: '', technologies: [], featured: false, sort_order: 0 }} onSubmit={handleSave} onCancel={() => { setShowForm(false); setEditing(null) }} loading={saving} />
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  )
}
